import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function CircularColor() {
  return <CircularProgress color="inherit" />;
}
